import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  useVerificationRequestMutation$data,
  type useVerificationRequestMutation as UseVerificationRequestMutation
} from '@/__generated__/useVerificationRequestMutation.graphql'

type CommitAsyncFn = (toUserId: string) => Promise<useVerificationRequestMutation$data>

export const useVerificationRequestMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isVerificationRequesting] = useMutation<UseVerificationRequestMutation>(graphql`
    mutation useVerificationRequestMutation($input: CreateVerificationRequestInput!) {
      createVerificationRequest(input: $input) {
        clientMutationId
        verificationRequest {
          toUser {
            profile {
              verificationRequested
            }
          }
        }
      }
    }
  `)

  const verificationRequest = useCallback<CommitAsyncFn>(
    (toUserId: string) =>
      new Promise((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              resolve(response)
            }
          },
          variables: {
            input: {
              verificationRequest: {
                toUserId
              }
            }
          }
        })
      ),
    [commit]
  )

  return [verificationRequest, isVerificationRequesting]
}
